<template>
  <div class="next-slide">
    <div class='next-slide__slide' :class="{'next-slide__slide--next': startAnimation}" :style="{backgroundImage: 'url(\'' + nextSlide.img + '\')'}">
      <transition name="slide-fade">
        <div v-if="!startAnimation" class="next-slide__content">
          <a class="button button--big button--outline-light" v-on:click="goToNextCase($event)" :style="{backgroundColor: nextSlide.color, color: nextSlide.color}" href="#"><span>{{nextSlideTitle || nextSlide.title}}</span></a>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import {getUrl} from '../../utils/UrlHelper';

  export default {

    props: ['post', 'onStart', 'showCurrent', 'nextSlideTitle'],
    data() {
      return {
        startAnimation: false,
      };
    },
    computed: {
      nextSlide() {
        return this.showCurrent ? this.post : this.$store.getters.getNextSlide(this.post.id);
      }
    },
    methods: {
      goToNextCase(event) {
        event.preventDefault();
        this.startAnimation = true;
        
        if (this.onStart) {
          this.onStart();
        }
        const scrollStep = (document.body.scrollTop || document.documentElement.scrollTop)/ 60;
        let interval = setInterval(() => {
          if (document.body.scrollTop!=0 || document.documentElement.scrollTop!=0){
            window.scrollBy(0,-scrollStep);
          } else {
            clearInterval(interval);
          }
        }, 5);
        this.$store.commit('setHero', {
          hideTitle: true,
        });
        setTimeout(() => {
          const slide = {
            ...this.nextSlide,
            video: this.nextSlide.acf.video,
            img: this.nextSlide.featured_image_url,
            title: this.nextSlide.title,
            url: this.nextSlide.type === 'link_slide' ? this.nextSlide.acf.outgoing_url.url : this.nextSlide.link,
            excerpt: this.nextSlide.excerpt
          };

          this.$store.commit('setHero', {
            slides: [slide],
            showSlideShow: false,
            hideTitle: false,
          });
          this.$router.push(getUrl(this.nextSlide.url))
        }, 1000);
      },
    },
  };


</script>

<style lang="scss">
  @import "./style";
</style>